/* Cart drawer Sooya. Pilote le contenu du drawer natif du thème via l'API AJAX du panier. */
(function(){
  var root=null,BASE_TH=59900,TMIN=5,tId=null,CUR=null,LOC='cs-CZ';

  function q(sel){return root?root.querySelector(sel):null;}

  /* Devise réelle du marché affiché. /cart.js renvoie des centimes dans la devise de PRÉSENTATION,
     donc on formate avec cette devise, jamais avec un symbole codé en dur. */
  function currency(){
    if(CUR)return CUR;
    if(window.Shopify&&Shopify.currency&&Shopify.currency.active)return Shopify.currency.active;
    return 'CZK';
  }
  function fmt(cents){
    var cur=currency();
    try{
      return new Intl.NumberFormat(LOC,{style:'currency',currency:cur,minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
    }catch(e){
      return (cents/100).toFixed(2).replace('.',',')+' '+cur;
    }
  }
  /* Le seuil est défini dans la devise de la boutique. On le convertit au taux du marché courant. */
  function threshold(){
    var r=1;
    if(window.Shopify&&Shopify.currency&&Shopify.currency.rate){
      var p=parseFloat(Shopify.currency.rate);
      if(!isNaN(p)&&p>0)r=p;
    }
    return BASE_TH*r;
  }
  function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML;}

  function startTimer(reset){
    var key='sooya_timer_end';
    var end=parseInt(sessionStorage.getItem(key)||'0',10);
    if(reset||!end||end<Date.now()){end=Date.now()+TMIN*60000;sessionStorage.setItem(key,end);}
    if(tId)clearInterval(tId);
    function tick(){
      var left=Math.max(0,end-Date.now());
      var m=Math.floor(left/60000),s=Math.floor((left%60000)/1000);
      var el=q('[data-syc-clock]');
      if(el)el.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
      if(left<=0&&tId){clearInterval(tId);tId=null;}
    }
    tick();tId=setInterval(tick,1000);
  }

  function itemHTML(it){
    var saved=(it.original_line_price||0)-(it.final_line_price||0);
    var img=it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2')+'" alt="">':'';
    var badge=saved>0?'<span class="syc__itbadge">1 + 1 ZDARMA</span>':'';
    var was=saved>0?'<span class="syc__itwas">'+fmt(it.original_line_price)+'</span>':'';
    var save=saved>0?'<span class="syc__itsave">Ušetříte '+fmt(saved)+'</span>':'';
    var prefix=it.quantity>1?it.quantity+'× ':'';
    return '<div class="syc__it" data-key="'+it.key+'">'+
      '<div class="syc__itimg">'+img+'</div>'+
      '<div><p class="syc__itname">'+prefix+esc(it.product_title)+'</p>'+badge+
        '<div class="syc__qty"><button type="button" data-d="-1">−</button><span>'+it.quantity+'</span><button type="button" data-d="1">+</button></div>'+
      '</div>'+
      '<div class="syc__itright">'+was+'<span class="syc__itnow">'+fmt(it.final_line_price)+'</span>'+save+
        '<button type="button" class="syc__del" aria-label="Odebrat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg></button>'+
      '</div></div>';
  }

  function render(cart){
    if(!root)return;
    if(cart.currency)CUR=cart.currency;

    var c=q('[data-syc-count]'); if(c)c.textContent=cart.item_count;
    var wrap=q('[data-syc-items]'); if(wrap)wrap.innerHTML=cart.items.map(itemHTML).join('');
    var em=q('[data-syc-empty]'); if(em)em.hidden=cart.item_count>0;
    var ups=q('[data-syc-ups]'); if(ups)ups.hidden=cart.item_count===0;

    var TH=threshold();
    var sub=cart.items_subtotal_price,left=TH-sub;
    var txt=q('[data-syc-shiptxt]'),bar=q('[data-syc-bar]');
    if(txt&&bar){
      if(left<=0){txt.innerHTML='<strong>Doprava zdarma</strong> odemčena!';bar.style.width='100%';}
      else{txt.innerHTML='Přidejte ještě <strong>'+fmt(left)+'</strong> a máte <strong>dopravu zdarma</strong>!';bar.style.width=Math.min(100,sub/TH*100)+'%';}
    }

    var saved=cart.items.reduce(function(a,i){return a+((i.original_line_price||0)-(i.final_line_price||0));},0);
    var d=q('[data-syc-disc]');
    if(d){
      if(saved>0){d.hidden=false;q('[data-syc-disclist]').innerHTML='<span class="tag">1 + 1 ZDARMA</span>';q('[data-syc-discamt]').textContent='−'+fmt(saved);}
      else d.hidden=true;
    }
    var t=q('[data-syc-total]'); if(t)t.textContent=fmt(cart.total_price);

    var inCart=cart.items.map(function(i){return String(i.variant_id);});
    root.querySelectorAll('.syc__up').forEach(function(u){u.style.display=inCart.indexOf(u.dataset.vid)>-1?'none':'';});
  }

  function refresh(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(render);}

  function change(key,qn){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qn})}).then(function(r){return r.json();}).then(function(c){render(c);startTimer(true);syncBubble(c);});
  }

  function syncBubble(cart){
    document.querySelectorAll('.theme-drawer__badge, [data-cart-count]').forEach(function(b){b.textContent=cart.item_count;});
  }

  function openDrawer(){
    var d=document.getElementById('cart-drawer');
    if(!d)return false;
    if(typeof d.open==='function'){d.open();return true;}
    if(typeof d.show==='function'){d.show();return true;}
    var dlg=d.querySelector('dialog');
    if(dlg&&typeof dlg.showModal==='function'){try{dlg.showModal();return true;}catch(e){}}
    return false;
  }

  function bind(){
    root=document.querySelector('[data-sooya-cart]');
    if(!root)return;
    BASE_TH=parseInt(root.dataset.threshold,10)||59900;
    TMIN=parseInt(root.dataset.timer,10)||5;
    LOC=document.documentElement.getAttribute('lang')||'cs-CZ';

    var items=q('[data-syc-items]');
    if(items&&!items.dataset.bound){
      items.dataset.bound='1';
      items.addEventListener('click',function(e){
        var row=e.target.closest('.syc__it'); if(!row)return;
        var key=row.dataset.key;
        var qn=parseInt(row.querySelector('.syc__qty span').textContent,10);
        if(e.target.closest('.syc__del'))return change(key,0);
        var b=e.target.closest('.syc__qty button');
        if(b)return change(key,Math.max(0,qn+parseInt(b.dataset.d,10)));
      });
    }

    root.querySelectorAll('.syc__upadd').forEach(function(b){
      if(b.dataset.bound)return; b.dataset.bound='1';
      b.addEventListener('click',function(){
        var vid=b.closest('.syc__up').dataset.vid;
        b.disabled=true;b.textContent='…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:vid,quantity:1}]})}).then(function(){
          b.disabled=false;b.textContent='Přidat';refresh().then(function(){startTimer(true);});
        });
      });
    });

    startTimer();refresh();
  }

  window.SooyaCart={open:function(){openDrawer();bind();refresh();startTimer(true);},refresh:refresh,bind:bind};

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);
  else bind();
  document.addEventListener('shopify:section:load',bind);
})();
